import { proxyBE } from './common';

export const lessonOnSiteService = {   

     MyScheduleOnSite(courseId, rCode) {
        let url = `/lesson/onsite/my-schedule-onsite/${courseId}/${rCode}`;
        return proxyBE.get(url);
    },

    myOnSite(id, registrationCode) {
        return proxyBE.get('/lesson/onsite/my-onsite/' + registrationCode + '/' + id);
    },

    generateAttendance(payload) {
        return proxyBE.post('/lesson/onsite/create-attendance/', { payload });
    },

    myAnalyticResume(rCode) {
        return proxyBE.post('/lesson/onsite/my-analytics-resume/' + rCode);
    },

    donwloadAttendance(id) {
        return proxyBE.get('/lesson/onsite/download-attendance/' + id);
    },

    loadFile(fileId) {
        return proxyBE.get('/lesson/onsite/schedule-file-slide/get/' + fileId);
    },    
}